import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authUserReducer from './authSlice';
import customerReducer from './customerSlice';

// Combine reducers
const rootReducer = combineReducers({
  authUser: authUserReducer,
  customer: customerReducer,
});

// Create store (no redux-persist, no extra middleware)
const store = configureStore({
  reducer: rootReducer,
});

export { store };
